export default class ProjectMessage {

    public fromUserId         : any
    public sysStatusNew       : any
    public sysStatusOld       : any

    public projectId          : any

    public projectStatusId    : any

    public type               : any

    
    
    constructor(data:any) {

        this.fromUserId         = data['fromUserId']
        this.sysStatusNew       = data['sysStatusNew']
        this.sysStatusOld       = data['sysStatusOld']

        this.projectId          = data['projectId']

        this.projectStatusId    = data['projectStatusId']

        this.type               = data['type'] // TaskMessageType (is used to be gd.const.taskMessage.type)
        // PRIORITY, SET_DEADLINE, CHANGE_DEADLINE, REMOVE_DEADLINE, ESTIMATE, MOVE, START_END, ADD_USER types suit for project
        // maybe should add some more (?)

        return this
    }
}
